import { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from '@tanstack/react-router'
import { useAuth } from '../../hooks/useAuth'
import { BrandMark } from '@/common/components/brand-mark'
import * as styles from './ManagerNav.css'

interface NavItem {
  label: string
  to: '/manager' | '/manager/timesheets' | '/manager/team'
}

const navItems: NavItem[] = [
  { label: 'Dashboard', to: '/manager' },
  { label: 'Timesheets', to: '/manager/timesheets' },
  { label: 'Team', to: '/manager/team' },
]

export function ManagerNav() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email
    : 'User'

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = async () => {
    setIsDropdownOpen(false)
    await logout()
    window.location.href = '/'
  }

  return (
    <nav className={styles.navbar}>
      <div className={styles.content}>
        <div className={styles.left}>
          <Link to="/manager" className={styles.brand}>
            <BrandMark />
          </Link>

          <div className={styles.links}>
            {navItems.map((item) => {
              const isActive =
                item.to === '/manager'
                  ? location.pathname === '/manager' || location.pathname === '/manager/'
                  : item.to === '/manager/timesheets'
                    ? location.pathname.startsWith(item.to) || location.pathname.startsWith('/approvals')
                    : location.pathname.startsWith(item.to)

              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`${styles.link} ${isActive ? styles.linkActive : ''}`}
                >
                  {item.label}
                </Link>
              )
            })}
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.dropdownContainer} ref={dropdownRef}>
            <button
              className={styles.userBtn}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              aria-expanded={isDropdownOpen}
              aria-haspopup="true"
            >
              <span className={styles.userName}>{displayName}</span>
            </button>

            {isDropdownOpen && (
              <div className={styles.dropdownMenu}>
                <button className={styles.dropdownItem} onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}
